<menu-options [menuOptions]="data" (close)="close.emit()"></menu-options>
